import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import Cotizacion5 from "../../components/Cotizacion/Cotizacion5ConfirmacionFinal";
import Cotizacion5Error from "../../components/Cotizacion/Cotizacion5ConfirmacionFinalError";
import Cotizacion5Pendiente from "../../components/Cotizacion/Cotizacion5ConfirmacionFinalPendiente";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { consultarPlacaFetch,listarColoresFetch, recuperarDatosFacturacionFetch } from "../../redux/actions/aCotizacion";
import { FetchDataProductosCarrito } from "../../redux/actions/ACarritoProductos";
import LoadingScreen from "react-loading-screen";
//import Perfil from "components/Perfil/Perfil";
//import Rcontrasena from "components/Login/Recuperar_contrasena";
//import Camcontrasena from "components/Perfil/Cambiar_contrasena";
import { withToastManager } from 'react-toast-notifications';
import { FetchPost } from "../../redux/actions/api";
import {urlEnviarFVinculacionCliente } from "../../constants/urls";

class ContainerCotizacion5 extends React.Component {
  constructor(props) {
    super(props);
    //console.log("continuo flujo1")
    const queryParams = new URLSearchParams(this.props.location.search);
    //const idCarrito=queryParams.get('id');
    const estado=queryParams.get('estado');
    this.state= {estado:estado, isLoading:false}
    //console.log('assuming query param is id', queryParams.get('id'));
    console.log('estado',estado);
  }

  async componentDidMount() {
    console.log('Did',this.props);
    //console.log("continuo flujoDid")
    const {estado} = this.state
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito=queryParams.get('id');  
    const resumen=queryParams.get('resumen');  
    let datosJSON ='';
    /*Consulta Carrito*/  
    datosJSON = {
      empresa:"AIGMETROPOLITANA",
      plataforma:"WEB",
      idCarrito: idCarrito
    }    
    await this.props.datosFacturacion(datosJSON);     
    if(this.props.dataFacturacion !== undefined && this.props.dataFacturacion.carDescripcionRamo && this.props.dataFacturacion.carDescripcionRamo !== 'VEHÍCULOS')
    { 
      if(resumen !== undefined && resumen !== null && resumen !== "")
      {
        this.props.history.push({
          pathname: "/final-cotizacion-general",
          search: `?id=${idCarrito}&estado=${estado}&resumen=1`
        });
      }
      else{
        this.props.history.push({
          pathname: "/final-cotizacion-general",
          search: `?id=${idCarrito}&estado=${estado}`
        });
      }
    }
    else{
      await this.props.listarColores();
      await this.props.listarCarrito(idCarrito);
      //Validar que el usuario logueado sea el mismo que realizó la compra
      if (this.props.datosUsuario.cliCodigoCore && this.props.datosUsuario.cliCodigoCore !== "" && this.props.datosUsuario.cliCodigoCore !== this.props.datosCarrito.productosCarrito.carDatosAsesor.codigoCore) {    
        this.props.history.push({
          pathname: "/recuperar-cotizacion-error",
          search: `?mensaje=usuarioincorrectoCompra`
        });
      }
    }    
  }

  onClickEnviarFormulario = async (e)  => {   
    this.setState({ isLoading: true });  
    const { toastManager } = this.props;            
    this.setState({ isLoading: true , texto:'Enviando Formulario de Vinculación'});
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito=queryParams.get('id');  

    let resp = await FetchPost({
      url: urlEnviarFVinculacionCliente+idCarrito,
      param:''
    });
    const { transaccion } = resp;    
    this.setState({ isLoading: false });  
    if (transaccion) {   
      const content = (
        <div>   
          Se ha enviado el formulario de vinculación al correo electrónico del cliente.              
        </div>
      );       
      toastManager.add(content, {
        appearance: 'success',
      });        
    }
    else{  
      const content = (
        <div>   
          No se ha podido enviado el formulario de vinculación al correo electrónico del cliente. Por favor intente nuevamente.
        </div>
      );       
      toastManager.add(content, {
        appearance: 'warning',
      });  
    }

    

  
    
  }

  render() {
    const {estado, isLoading} = this.state
    //console.log("RCCAACAC: ",this.props.datosCarrito)
    const queryParams = new URLSearchParams(this.props.location.search);
    const resumen=queryParams.get('resumen');
    let mostrarResumen=false
    if(resumen !== undefined && resumen !== null)
    {
      mostrarResumen=true
    }    
    var infFormulario= null;
    if(this.props.dataFacturacion && this.props.dataFacturacion.infFormVinculacion)
    {
      infFormulario=this.props.dataFacturacion.infFormVinculacion;
    }

    let textocargando=`Cargando estado de la ${this.props.datosUsuario && this.props.datosUsuario.usu_tipo_usuario !== 'cliente'?'venta':'compra'}`;
    if (isLoading)
    {
      textocargando='Enviando Formulario de Vinculación'
    }
    
    return (
      <LoadingScreen
      loading={this.props.datosCarrito.isLoading || isLoading}
      bgColor="#f1f1f1"
      spinnerColor="#001871"
      textColor="#676767"
      logoSrc={logo}
      text={textocargando}
    >
      {!this.props.datosCarrito.isLoading && !isLoading && <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
          {estado === "APROBADO" && !this.props.datosCarrito.isLoading && !isLoading   && <Cotizacion5 datosCotizacion={this.props.datosCotizacion} datosCarrito={this.props.datosCarrito} estado={estado} mostrarResumen={mostrarResumen} datosUsuario={this.props.datosUsuario} datosFVinculacion={infFormulario} enviarFormulario={this.onClickEnviarFormulario}/>}
          {estado === "PENDIENTE" && !this.props.datosCarrito.isLoading && !isLoading && <Cotizacion5Pendiente datosCotizacion={this.props.datosCotizacion} datosCarrito={this.props.datosCarrito} estado={estado} datosUsuario={this.props.datosUsuario} datosFVinculacion={infFormulario}/>}
          {estado === "RECHAZADO" && !this.props.datosCarrito.isLoading && !isLoading && <Cotizacion5Error datosCotizacion={this.props.datosCotizacion} datosCarrito={this.props.datosCarrito} estado={estado} datosUsuario={this.props.datosUsuario} datosFVinculacion={infFormulario}/>}
          </div>
        </div>
      </main>
      }
      
      </LoadingScreen>
    );
  }
}

const mapStateToProps = state => ({
  datosCotizacion: state.datosCotizacion,
  datosCarrito:state.dataProductoCarrito,
  datosUsuario: state.datosUsuarios.dataUsuario,
  dataFacturacion : state.dataFacturacion.datosFacturacion
});

const mapDispatchToProps = dispatch => {
  return {
    consultarPlaca: placa => dispatch(consultarPlacaFetch(placa)),
    listarCarrito:(idCarrito)=>dispatch(FetchDataProductosCarrito(idCarrito)),
    listarColores: () => dispatch(listarColoresFetch()),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
  };
};

export default withToastManager(withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacion5)
));
